import { render, staticRenderFns } from "./FantasyWordQuestion.vue?vue&type=template&id=5565cd1a&scoped=true"
import script from "./FantasyWordQuestion.vue?vue&type=script&lang=ts"
export * from "./FantasyWordQuestion.vue?vue&type=script&lang=ts"
import style0 from "./FantasyWordQuestion.vue?vue&type=style&index=0&id=5565cd1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5565cd1a",
  null
  
)

export default component.exports